import * as React from 'react';
import { ReactChild, ReactChildren } from 'react';

type JsonPanelProps = {
    children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[],
    className: string,
    arrow?: string
}

function JsonPanel({ children, className, arrow }: JsonPanelProps) {
    return (
        <div className={`chat-panel ${className} ${arrow && `with-arrow ${arrow}`}`}>
            {children}
        </div>
    );
}

export default JsonPanel;